import React from 'react';
import { useDispatch } from 'react-redux';
import CancelToDetails from '../../../../controllers/CancelToDetails';
import { actionCreators, sliceKeys } from '../../../../model';

const { stateReset } = actionCreators[sliceKeys.createPage];

const CancelCreate = () => {
  const dispatch = useDispatch();

  const resetFn = () => dispatch(stateReset());

  return <CancelToDetails resetFn={resetFn} />;
};

export default CancelCreate;
